import React from "react";
import { RouteComponentProps } from "react-router-dom";
import ImpiantoForm, { ImpiantoFormData, ToImpiantoData } from "./impiantoForm";
import ImpiantiTermiciActions from "../ImpiantiTermiciActions";
import { ImpiantoDto, ClienteDto } from "../../generated";
import { links } from "../../routes";
import { Loading } from "../../common/components/loading";
import ImpiantiTermiciStore from "../ImpiantiTermiciStore";

interface ImpiantoEditProps extends RouteComponentProps<{ id: string }> {
    impianto?: ImpiantoDto;
    cliente?: ClienteDto;
}

export default (props: ImpiantoEditProps) => {
    let { history, match: { params: { id } } } = props;

    const impianto = ImpiantiTermiciStore.use(parseInt(id));
    if (impianto == null)
        return <Loading />

    const save = async (i: ImpiantoFormData) => {
        ImpiantiTermiciActions.update(ToImpiantoData(i), +id);
        history.replace(links.customerShow(impianto.idCliente));
    }

    return (
        <ImpiantoForm
            impianto={impianto}
            onSubmit={save}
            onCancel={() => history.goBack()}
            isNew={!id}
        />

    );
}

